import { FocusEvent } from 'react';
import { ERROR_MAP } from './Validation';

export type FIELD_TYPE = { [x: string]: ValidateFn[] };

export enum ValidationColor {
  success = 'success',
  error = 'error',
}

export type FormState = {
  [x: string]: {
    value: string;
    color: ValidationColor | undefined;
    errorMessage: string | undefined;
  };
};

export type ValidationResult = {
  error?: string;
  color?: ValidationColor;
};

type ValidateFn = (value: string) => ValidationResult;

export type ValidatorFn = {
  value: string;
  validators: ValidateFn[];
};

// since we don't know the type we get from the backend the most generic type that applies
// Unless we have a way to map the whole data structure in flight
export type HubspotDataType = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
};

export type HsFormFields = {
  id: string;
  type: string;
  name: string;
  label: string;
  defaultValue: string;
  fieldType: string;
  required: boolean;
  hidden: boolean;
  placeholder: string;
  hideLabel?: boolean;
};

export type HubspotData = {
  fields: HsFormFields[];
  redirect?: string;
  portalId?: number;
  guid?: string;
};

export enum HubspotApiStatus {
  // API request is being made
  Loading = 'Loading',
  // API call was successful
  Success = 'Success',
  // API resulted in an error
  Error = 'Error',
}

export type HubspotApiData = {
  status?: HubspotApiStatus;
  error?: Error | null;
  data?: HubspotData | null;
};

type HubspotApiError = {
  message: string;
  errorType: keyof typeof ERROR_MAP;
};

export type HubspotApiReturnStatus = {
  status: string;
  message: string;
  errors: HubspotApiError[];
  redirectUri?: string;
};

export type HsContext = {
  hutk: string;
  pageName: string;
  pageUri: string;
};

export type HsCommunicationDTO = {
  text: string;
  subscriptionTypeId: number;
  value: boolean;
};

export type HsConsent = {
  [key in 'consent']: {
    communications: HsCommunicationDTO[];
    consentToProcess: boolean;
    text: string;
  };
};
export type HsFormValues = Pick<HsFormFields, 'name'> & { value: string };

export type HubspotDTO = {
  context: HsContext;
  fields: HsFormValues[];
  legalConsentOptions?: HsConsent;
};

export type SubmissionDataOptions = {
  formFields: HsFormFields[];
  formData: FormState;
};

export type HubspotInputType = {
  fields: HsFormFields[] | undefined;
  formData: FormState;
  handleOnBlur(e: FocusEvent<HTMLInputElement>): void;
};

// Johnny's defined type
export type HubspotFormType = {
  customOnSubmitFunction?: Function;
};
